'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require('../../../constants');

var _components = require('../../../components');

var _beautifyNumber = require('../../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);

var _FullScreenPropertyCellPropertySummary = require('./FullScreenPropertyCellPropertySummary.scss');var styles = _interopRequireWildcard(_FullScreenPropertyCellPropertySummary);
var _note = require('../../../../static/icons/note.svg');var _note2 = _interopRequireDefault(_note);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Constants
// Components
// Helpers
// Styles
var FullScreenPropertyCellPropertySummary = function (_Component) {_inherits(FullScreenPropertyCellPropertySummary, _Component);function FullScreenPropertyCellPropertySummary() {var _temp, _this, _ret;_classCallCheck(this, FullScreenPropertyCellPropertySummary);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { showNote: false }, _this.


    renderPrice = function () {var
      isRtl = _this.props.isRtl;var _ref =
      [_react2.default.createElement('i', { className: styles.currency }, '\u20AA'), (0, _beautifyNumber2.default)(_this.props.price)],currency = _ref[0],price = _ref[1];
      if (isRtl) {var _ref2 =
        [price, currency];currency = _ref2[0];price = _ref2[1];
      }
      return (
        _react2.default.createElement('span', { className: styles.propertyPrice },
          currency, ' ', price));


    }, _this.

    renderNote = function () {return !!_this.props.propertyNote &&
      _react2.default.createElement('div', { className: styles.noteIconWrapper },
        _react2.default.createElement('img', {
          src: _note2.default,
          alt: '',
          className: styles.noteIcon,
          onClick: function onClick() {
            _this.setState({ showNote: !_this.state.showNote });
          } }),

        _this.state.showNote &&
        _react2.default.createElement('div', { className: styles.noteTooltip },
          _react2.default.createElement(_components.NoteInput, {
            value: _this.props.propertyNote,
            addNote: function addNote(note) {return _this.props.addPropertyNote(_this.props.id, note);} })));}, _temp), _possibleConstructorReturn(_this, _ret);}FullScreenPropertyCellPropertySummary.prototype.






  render = function render() {var _props =
    this.props,locale = _props.locale,propertyType = _props.propertyType,address = _props.address;
    var englishAddressRequired = _constants.localesWithEnglishAddress.includes(locale);
    var propertyAddress = englishAddressRequired ?
    address.en :
    address[locale] || address[_constants.language.default];
    var houseNumber = propertyAddress.house_number ? ' ' + propertyAddress.house_number + ',' : '';
    var addressString = propertyAddress.street_name + ' ' + houseNumber;
    return (
      _react2.default.createElement('div', { className: styles.propertySummary },
        _react2.default.createElement('div', { className: styles.propertyType }, propertyType),
        _react2.default.createElement('div', { className: styles.propertyAddress }, addressString),
        _react2.default.createElement('div', { className: styles.propertyAddress }, propertyAddress.city_name),
        _react2.default.createElement('div', { className: styles.propertyPrice }, this.renderPrice()),
        _react2.default.createElement('div', null, this.renderNote())));


  };return FullScreenPropertyCellPropertySummary;}(_react.Component);exports.default = FullScreenPropertyCellPropertySummary;


FullScreenPropertyCellPropertySummary.propTypes = {
  locale: _propTypes2.default.string,
  address: _propTypes2.default.object,
  propertyType: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  price: _propTypes2.default.number,
  id: _propTypes2.default.string,
  propertyNote: _propTypes2.default.string,
  addPropertyNote: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FullScreenPropertyCell/FullScreenPropertyCellPropertySummary/FullScreenPropertyCellPropertySummary.js
// module id = 2695
// module chunks = 0